import tinycolor from '../loaders/tinycolor2';
import Preset from './Preset';
import Color from '../utils/Color';

export default class TextPreset extends Preset {
  /**
   * @param app {PIXI.Application}
   */
  constructor({ app, isFullScreen = false, requiresRootTransform = false }) {
    super({ app, isFullScreen, requiresRootTransform });

    this.secondaryColor = Color.BLACK;
  }

  scaleFontForScreen(size) {
    return (this.app.screen.height * size) / 300;
  }

  update(model, rootConfigs) {
    super.update(model, rootConfigs);

    this.align = model.style.align;
    this.secondaryColor = tinycolor(model.secondaryColor);

    this.originalFontSize = model.fontSize;
    this.fontSize = this.scaleFontForScreen(model.fontSize);

    this.textLines = model.text.trim().split('\n') || [];
  }

  /**
   * @param text {Text}
   * @param mask {GraphicMask}
   */
  setMaskOnText(text, mask = null) {
    const { x, y, width, height } = text.innerControls;
    Object.assign(mask, { x, y, width, height });
  }

  get numTextLines() {
    return this.textLines.length;
  }

  getTextLine(index) {
    if (!this.textLines) {
      return '';
    }

    if (index < 0) {
      index += this.numTextLines;
    }

    return this.textLines[index] || '';
  }

  getTextLines(from, to) {
    if (!this.textLines) {
      return '';
    }

    return this.textLines.slice(from, to).join('\n');
  }
}
